import React, { Component } from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

class DefaultModal extends Component{
    constructor(props) {
        super(props);
        this.state = {};
        this.isOpen = this.isOpen.bind(this);
    }

    componentDidMount() {
        if (this.props.closeOnEsc === undefined || this.props.closeOnEsc === true) {
            this.setState({closeOnEsc: true});
        }
    }

    isOpen() {
        this.props.listener();
    }

    render() {
        return (
          <Modal isOpen={this.props.isOpen}
                 toggle={this.state.closeOnEsc && this.props.onCancel}
                 size={this.props.size || "md"}
                 backdrop="static"
                 >

              <ModalHeader toggle={this.props.onCancel}>

                  <div style={{display:"inline-flex"}}>
                      <label>{this.props.title || ""}</label>
                      {this.props.secondaryButton &&
                      this.props.secondaryButton
                      }
                  </div>

              </ModalHeader>
              {/*<ModalBody style={this.props.modalBodyStyle ? this.props.modalBodyStyle :  {padding: "0", overflow: 'auto', overflowY: 'scroll', overflowX: 'hidden'}}>*/}
              <ModalBody style={this.props.modalBodyStyle ? this.props.modalBodyStyle :  {padding: "0"}}>
                  <div className="col-sm-12" style={{marginTop:(this.props.title ? "10px":"28px"), marginBottom:"5px"}}>
                      {this.props.children}
                  </div>
              </ModalBody>
              {(this.props.confirmBtnText || this.props.cancelBtnText || this.props.applyBtnText) &&
              <ModalFooter>
                  <nav className=" col-sm-12" style={{paddingLeft:"0px", paddingRight:"0px"}}>
                      {this.props.cancelBtnText &&
                      <button type="button"
                              className={this.props.cancelBtnCssClass ? this.props.cancelBtnCssClass :"btn-sm btn-icon TekBtn vazgec"}

                              style={this.props.cancelBtnStyle ? this.props.cancelBtnStyle :{
                                  background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                  float: 'left' , padding:'9px 45px 9px 20px'
                              }}
                              onClick={this.props.onCancel}>{this.props.cancelBtnText}
                      </button>
                      }
                      {this.props.applyBtnText &&
                      <button type="button"
                              className={"btn-sm btn-icon TekBtn kaydet"}
                              style={{float: 'left' , padding:'9px 45px 9px 20px'}}
                              onClick={this.props.onApply}>{this.props.applyBtnText}
                      </button>
                      }
                      {this.props.confirmBtnText &&
                      <button type="button"
                              disabled={this.props.disabled}
                              className={this.props.cancelBtnCssClass ? this.props.cancelBtnCssClass :"btn-sm btn-icon TekBtn kaydet"}
                              style={this.props.cancelBtnStyle ? this.props.cancelBtnStyle :{float: 'right' , padding:'9px 45px 9px 20px'}}
                              onClick={this.props.onConfirm}>{this.props.confirmBtnText}
                      </button>
                      }
                  </nav>
              </ModalFooter>
              }
          </Modal>);
    }

}

export default DefaultModal;